<script setup lang="ts">
const colorMode = useColorMode()

function cycle() {
  const values = ['system', 'light', 'dark'] as const
  const i = values.indexOf(colorMode.preference as typeof values[number])
  colorMode.preference = values[(i + 1) % values.length] ?? 'system'
}
</script>

<template>
  <button
    type="button"
    class="flex w-6 h-6 text-gray-700 dark:text-gray-300 hover:text-primary-500 transition-colors"
    aria-label="Color theme: cycle system, light, dark"
    @click="cycle"
  >
    <svg v-if="colorMode.preference === 'dark'" xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M12 3a9 9 0 1 0 9 9c0-.46-.04-.92-.1-1.36a5.389 5.389 0 0 1-4.4 2.26 5.403 5.403 0 0 1-3.14-9.8c-.44-.06-.9-.1-1.36-.1z" />
    </svg>
    <svg v-else-if="colorMode.preference === 'light'" xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M12 7a5 5 0 1 0 0 10 5 5 0 0 0 0-10zM2 13h2a1 1 0 0 0 0-2H2a1 1 0 0 0 0 2zm18 0h2a1 1 0 0 0 0-2h-2a1 1 0 0 0 0 2zM11 2v2a1 1 0 0 0 2 0V2a1 1 0 0 0-2 0zm0 18v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-2 0z" />
    </svg>
    <svg v-else xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M21 14H3V4h18v10zm2 2H1V2h22v14zM7 22h10v2H7v-2z" />
    </svg>
  </button>
</template>
